import { WarehouseCheckInService } from "src/services";
import { FILE_TYPE_SUFFIX } from "src/helpers";
import { WarehouseCheckInFileType } from "src/enums";
import { useFileDownload } from "../useFileDownload";

type DownloadParams =
  | {
      type: WarehouseCheckInFileType.CHECK_IN_IMAGES;
      warehouseCheckInId: string;
      timestamp: string;
    }
  | {
      type: WarehouseCheckInFileType.GOODS_IN_EXPORTS;
      exportFileId: string;
    };

export const useWarehouseCheckInFileDownload = (warehouseCheckInService: WarehouseCheckInService) => {
  const {
    mutate: download,
    isPending: isFileDownloading,
    error: FileLoadError,
    reset: resetDownload,
    retry: retryDownload
  } = useFileDownload<File | File[]>();

  const downloadWarehouseCheckInFile = (params: DownloadParams) => {
    switch (params.type) {
      case WarehouseCheckInFileType.CHECK_IN_IMAGES:
        return download({
          getFileData: () =>
            warehouseCheckInService.getWarehouseCheckInImages(params.warehouseCheckInId, params.timestamp),
          zipName: `${params.warehouseCheckInId}${FILE_TYPE_SUFFIX[params.type]}`
        });

      case WarehouseCheckInFileType.GOODS_IN_EXPORTS:
        return download({
          getFileData: () => warehouseCheckInService.getGoodsInExportUrl(params.exportFileId)
        });
    }
  };

  return {
    downloadFile: downloadWarehouseCheckInFile,
    isFileDownloading,
    FileLoadError,
    resetDownload,
    retryDownload
  };
};
